import { render, staticRenderFns } from "./ComponentLoader.vue?vue&type=template&id=95cf3f7e&scoped=true&"
import script from "./ComponentLoader.vue?vue&type=script&lang=js&"
export * from "./ComponentLoader.vue?vue&type=script&lang=js&"
import style0 from "./ComponentLoader.vue?vue&type=style&index=0&id=95cf3f7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cf3f7e",
  null
  
)

export default component.exports